import React from 'react';
import PropTypes from 'prop-types';
import { X } from '@wix/wix-ui-icons-common';
import IconButton from '../IconButton';

import { st, classes } from './ModalMobileLayout.st.css';
import { ModalMobileLayoutProps } from './ModalMobileLayout.types';
import Title from './components/Title/Title';
import Footer from './components/Footer/Footer';

const ModalMobileLayout = ({
  dataHook,
  className,
  title,
  content,
  footer,
  onOverlayClick,
  onCloseButtonClick,
  fullscreen = false,
  stickyTitle = false,
  stickyFooter = false,
}: ModalMobileLayoutProps) => {
  return (
    <div
      id="modalMobileLayout-root"
      data-hook={dataHook}
      className={st(
        classes.root,
        {
          fullscreen,
          noTitle: !title,
          noFooter: !footer,
        },
        className,
      )}
      onClick={({ target }) => {
        target instanceof HTMLElement &&
          target.id === 'modalMobileLayout-root' &&
          onOverlayClick &&
          onOverlayClick();
      }}
    >
      <div className={classes.container}>
        {onCloseButtonClick && (
          <div className={classes.close}>
            <IconButton
              dataHook="modalMobileLayout-close-button"
              skin="light"
              onClick={onCloseButtonClick}
            >
              <X />
            </IconButton>
          </div>
        )}
        {title && stickyTitle && <Title isSticky>{title}</Title>}
        <div className={classes.content} data-hook="modalMobileLayout-content">
          <div>
            {title && !stickyTitle && <Title>{title}</Title>}
            {content}
            {footer && !stickyFooter && <Footer>{footer}</Footer>}
          </div>
        </div>
        {footer && stickyFooter && <Footer isSticky>{footer}</Footer>}
      </div>
    </div>
  );
};

ModalMobileLayout.displayName = 'ModalMobileLayout';

ModalMobileLayout.propTypes = {
  dataHook: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.node,
  stickyTitle: PropTypes.bool,
  content: PropTypes.node,
  footer: PropTypes.node,
  stickyFooter: PropTypes.bool,
  onOverlayClick: PropTypes.func,
  onCloseButtonClick: PropTypes.func,
  fullscreen: PropTypes.bool,
};

export default ModalMobileLayout;
